export default "__VITE_ASSET__BkHuAffn__"